import { PropertyType } from '../../../models/';

export const DateFormat = {
    modelName: 'dateFormat',
    propertyType: PropertyType.Text,
    label: 'Date format',
    placeholder: 'Date format',
    propertyName: 'dateFormatProperty',
    required: false,
    helpReference: '_General_information/Formatting_dates/',
    icon: 'fa-calendar-o'
};